import dashboardApi from '../../api/dashboard'
import moment from 'moment'

// initial state
const state = {
}

// getters
const getters = {
  // activityItems (state, getters, rootState) {
  //   return rootState.shifts.owned
  //     .filter(shift => moment(shift.startDatetime).isAfter())
  //     .slice(0,6)
  //   //.concat(rootState.tasks.items) // TODO: add tasks to this list
  //   // TODO: sort all by date. what to do with date-less tasks?
  // }
}

// actions
const actions = {
  getInitialDashboardData ({ dispatch, commit, rootState }) {
    return new Promise((resolve, reject) => {
      dashboardApi.getInitialData(initialData => {
        dispatch('shifts/setOwned', initialData.shifts, { root: true })
        dispatch('tasks/setTasks', initialData.tasks, { root: true })
        resolve()
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
